import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';

export interface Product {
  description?: string;
  _id: string;
  title: string;
  slug: string;
  price: number;
  name?: string;
  discount?: string;
  imageUrl?: string;
  images?: Array<{ url: string; altText?: string; isDefault?: boolean }>;
  // Optional createdAt for sorting by newest
  createdAt?: string;
  variants?: any[];
  isActive?: boolean;
  isFeatured?: boolean;
  categories?: Array<{ _id: string; name: string; slug: string }>;
  tags?: string[];
  compareAtPrice?: number;
  quantity?: number;
}

export interface ProductResponse {
  success: boolean;
  data: Product[];
}

class SubcategoryProductService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getProductsByCategory(categorySlug: string, limit?: number, page?: number): Promise<ProductResponse> {
    const params: any = {};
    if (limit) params.limit = limit;
    if (page) params.page = page;
    
    return this.__Apiservice.getRequest(`products/category/${categorySlug}`, params, {
      apiRoot: this.apiRootServer,
    });
  }
}

const subcategoryProductService = new SubcategoryProductService();
export default subcategoryProductService;
